/*!
 * @Author: luoob
 * @Date: 2021-03-23 14:52:00
 * @Last Modified by: luoob
 * @Last Modified time: 2021-03-23 14:52:00
 * @Introduction: 新闻模块路由
 */

const NewsList = () => import('@/views/news/list.vue')
const NewsDetail = () => import('@/views/news/detail.vue')
const NewsComments = () => import('@/views/news/comments.vue')
const NewsEdit = () => import('@/views/news/edit.vue')
/* Layout */
import Layout from '@/layout/index.vue'

export default {
    path: '/news',
    component: Layout,
    redirect: '/news/list',
    meta: {
        title: '新闻',
        icon: 'icon-news',
        alwaysShow: true // will always show the root menu
    },
    children: [
        {
            path: 'list',
            component: NewsList,
            name: 'NewsList',
            meta: {
                title: '新闻列表'
            }
        },
        {
            path: ':id',
            component: NewsDetail,
            name: 'NewsDetail',
            meta: {
                title: '新闻详情',
                hidden: true
            }
        },
        {
            path: ':id/comments',
            component: NewsComments,
            name: 'NewsComments',
            meta: {
                title: '评论列表',
                hidden: true
            }
        },
        {
            path: ':id/edit',
            component: NewsEdit,
            name: 'NewsEdit',
            meta: {
                title: '新闻编辑',
                hidden: true
            }
        }
    ]
}
